<template>
  <v-card tile flat min-width="100%">
    <v-card-title class="text-h6 orange lighten-4">
      Evaluation continue
      <v-btn color="primary" class="mx-5" small @click="createEvaluation()">Ajouter</v-btn>
    </v-card-title>
    <v-dialog v-model="dialog">
      <evaluation-form
        formTitle="Ajouter l'évaluation continue"
        :evaluation="evaluation"
        :evaluation_type="student_course.course.type"
        @save="handleSaveTest"
        @cancel="dialog = false"
      ></evaluation-form>
    </v-dialog>

    <v-data-table
      item-key="evaluation.key"
      :loading="loading"
      :headers="headers"
      :items="evaluations"
      :no-data-text="'Aucun'"
      :items-per-page="1000"
      group-by="objective"
      hide-default-footer
    >
      <template v-slot:group.header="{ items, isOpen, toggle }">
        <th colspan="5">
          <v-icon @click="toggle">{{ isOpen ? "mdi-minus" : "mdi-plus" }}</v-icon>
          {{ items[0].objective }}
          <span class="mx-5 text-subtitle-2">{{ getAverageEvaluationsResult(items) }}</span>
        </th>
      </template>
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.date | dateToHuman }}</td>
          <td>
            <div class="d-flex flex-row">
              <div class="mr-4">
                <strong>{{ item.result }}%</strong>
              </div>
              <v-progress-linear v-model="item.result" :color="getColorFromResult(item.result)" height="20" />
            </div>
          </td>
          <td>
            <v-btn text icon color="green" @click="editItem(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </td>
          <td>
            <v-btn text icon color="red" @click="deleteItem(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import Evaluation from "@/models/Evaluation"
import EvaluationForm from "@/components/evaluations/EvaluationForm"

export default {
  components: {
    EvaluationForm,
  },
  props: {
    student_course: {
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    evaluation: null,
    headers: [
      {
        text: "Date",
        value: "date",
        align: "left",
      },
      {
        text: "Compétence",
        value: "objective",
        align: "left",
      },
      {
        text: "Resultat",
        value: "result",
        align: "left",
      },
      { text: "Actions", sortable: false, width: "10%" },
      { text: "", sortable: false, width: "10%" },
    ],
    loading: false,
  }),
  async mounted() {
    if (this.student_course_id) {
      await this.getDataFromApi()
    }
  },
  methods: {
    async getDataFromApi() {
      this.loading = true
      await Evaluation.getOneByStudentCourseId(this.student_course_id)
      this.loading = false
    },
    createEvaluation() {
      this.evaluation = new Evaluation()
      const options = { year: "numeric", month: "long", day: "numeric" }
      const currentDate = new Date().toLocaleDateString(undefined, options)

      this.evaluation.date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10)
      this.evaluation.student_course_id = this.student_course_id
      this.dialog = true
    },
    editItem(evaluation) {
      this.evaluation = evaluation
      this.dialog = true
    },
    async deleteItem(evaluation) {
      await Evaluation.deleteOne(evaluation.id)
      this.getDataFromApi()
    },
    async handleSaveTest(evaluation) {
      this.dialog = false
      this.loading = true
      if (evaluation.id != null) {
        await Evaluation.update(evaluation)
      } else {
        await Evaluation.create(evaluation)
      }
      await this.getDataFromApi()
    },
    getAverageEvaluationsResult(evaluations) {
      if (!evaluations.length) {
        return ""
      }

      const sum = evaluations.reduce((total, next) => total + next.result, 0)

      const avg = sum / evaluations.length || 0
      return avg.toFixed(2) + "%"
    },
    getColorFromResult(result) {
      let color = "red"
      if (result < 50) {
        color = "red"
      } else if (result < 70) {
        color = "orange"
      } else {
        color = "green"
      }
      return color + " lighten-2"
    },
  },
  computed: {
    student_course_id() {
      return this.student_course?.id
    },
    evaluations() {
      return Evaluation.query()
        .where((e) => e.student_course_id == this.student_course_id)
        .get()
    },
  },
  watch: {
    student_course_id: async function () {
      this.loading = true
      await this.getDataFromApi()
      this.loading = false
    },
  },
}
</script>
